import { useCallback } from "react";
import { setDrmTableFilter } from "../redux/reducers/drmDailyTableFilterSlice";

export const useDailyDrmFilters = (tableFilter, dispatch) => {
  const handleDestinationCity = useCallback(
    (value) => {
      const valuesArray = Array.isArray(value) ? value : value ? [value] : [];
      const destArray = valuesArray.map((n) => n.countryCode);
      dispatch(
        setDrmTableFilter({
          ...tableFilter,
          destinationCountries: destArray,
        })
      );
    },
    [tableFilter]
  );

  const handleOriginCity = useCallback(
    (value) => {
      const valuesArray = Array.isArray(value) ? value : value ? [value] : [];
      const OrgArray = valuesArray.map((n) => n.countryCode);
      dispatch(
        setDrmTableFilter({
          ...tableFilter,
          originCountries: OrgArray,
        })
      );
    },
    [tableFilter]
  );

  const handleDivision = useCallback(
    (value) => {
      const valuesArray = Array.isArray(value) ? value : value ? [value] : [];
      const divArray = valuesArray.map((n) => n.countryCode);
      dispatch(
        setDrmTableFilter({
          ...tableFilter,
          divisions: divArray,
        })
      );
    },
    [tableFilter]
  );

  return {
    handleDestinationCity,
    handleOriginCity,
    handleDivision,
  };
};
